export const resHandle = res => {
    let status = res.data.statusCode;
    let data;
    if (status) {
        data = res.data.responseData
    } else {
        data = (res.data.error && res.data.error.responseMessage)
            || (res.data.error && res.data.error.errorMessage)
            || 'Something went wrong'
    }
    return { status, data }
}

export const getDisplayMessage = (data, fallback = 'Something went wrong') => {
    if (typeof data === 'string') {
        return data;
    }
    if (data && typeof data.message === 'string') {
        return data.message;
    }
    return fallback;
}

export const getAxiosErrorMessage = (error, fallback = 'Something went wrong') => {
    if (!error) {
        return fallback;
    }

    if (error.code === 'ECONNABORTED') {
        return 'Request timed out. The server took too long to respond. Please try again.';
    }

    if (error.message === 'Network Error') {
        return 'Network error. Please check your connection and try again.';
    }

    const status = error.response && error.response.status;
    if (status === 504) {
        return 'Gateway timeout (504). The server took too long to respond. Please try again or use the development API.';
    }
    if (status === 502) {
        return 'Bad gateway (502). The server is temporarily unavailable.';
    }
    if (status === 503) {
        return 'Service unavailable (503). Please try again later.';
    }

    const data = error.response && error.response.data;
    if (data && data.error && data.error.responseMessage) {
        return data.error.responseMessage;
    }
    if (data && data.error && data.error.errorMessage) {
        return data.error.errorMessage;
    }
    if (data && typeof data.message === 'string') {
        return data.message;
    }

    if (status) {
        return `Request failed with status ${status}.`;
    }

    return fallback;
}

export const createHashSHA256 = async (value) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(value || '');
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
}


export const isColor = clr => {
    let s = new Option().style;
    s.color = clr;
    return s.color == clr;
}